// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3dCbb","error":"Textarea_error__W7FMP","readonly":"Textarea_readonly__LdIF8","disabled":"Textarea_disabled__oUdJF"};